import { HorizontalBar, mixins } from "vue-chartjs"
import * as mixChart from "@/plugins/charts.js"
const { reactiveProp } = mixins

export default {
  extends: HorizontalBar,
  mixins: [reactiveProp, mixChart.mixins],
  props: ["options"],
  data() {}
}
